module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch6_20210921044151_T.72e62c4e.jpg";